import React, { useState, useEffect, Fragment } from "react";
import { API_URL, createMarkup } from "../helpers";
import Hdg from "../components/Hdg";
import Nav from "../components/Nav";
import Alert from "../components/Alert";

const CharityIncentives = () => {
  const [html, setHtml] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const url = new URL(`${API_URL}/htmlInit`);
    const params = {
      left: `charity-incentives`,
      right: `right-featured-birdies`,
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setHtml({
          left: json.left,
          right: json.right,
        });
        setAlert({});
        window.jQuery(".cycle-slideshow").cycle("stop");
        window.jQuery(".cycle-slideshow").cycle();
      } else {
        setAlert({
          type: json.resp === 2 ? "notice" : "error",
          text: json.text,
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <Fragment>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <Fragment>
          <div id="left-column">
            <Hdg />
            <Nav />
            <div dangerouslySetInnerHTML={createMarkup(html.left)} />
          </div>
          <div
            id="right-column"
            dangerouslySetInnerHTML={createMarkup(html.right)}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

export default CharityIncentives;
